export enum ReportStatus {
  unknown = 'Unknown',
  success = 'Success',
  warning = 'Warning',
  issue = 'Issue',
  overdue = 'Overdue',
  disabled = 'Disabled'
}
